module.exports = __webpack_public_path__ + "static/media/Template_31.1f8c43f3.png";